(function () {
    'use strict';

    if (typeof window === 'undefined') {

        const _ = require('lodash');
        const instagramPaidMetricUtils = _.constant(require('../../../public/apps/insights/instagramPaidMetricsUtils.js'));
        module.exports = exportFn(
            require('../../../public/enums/metrics.js'),
            instagramPaidMetricUtils,
            require('../../../public/modules/data/linkedInJobFunctions.js'),
            _
        );

    } else {

        RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {
            data.metrics = exportFn(
                RivalIQ.enums,
                function () {
                    return RivalIQ.apps.Insights.utils;
                },
                RivalIQ.data.LinkedInJobFunctionMap,
                _
            );
        });
    }

    function exportFn(enums, instagramPaidMetricUtils, linkedInJobFunctionMap, _) {
        const sources = enums.sources;

        const sourceMetrics = {};
        const sourcePostMetrics = {};
        const sourceStoryMetrics = {};
        const sourceStoryDayMetrics = {};
        const sourcePostAggregateMetrics = {};
        const sourceStoryAggregateMetrics = {};

        const defaults = [
            'audience',
            // 'total_post_reach',
            {
                property: 'engagement_total',
                dimensions: ['engagement_type']
            },
            'avg_engagement_rate_per_post',
            'engagement_total_per_post'
        ];

        const postDefaults = [
            'audience',
            'engagement_total',
            'engagement_rate',
            'type',
            'presence_handle'
        ];


        let engagementTypes = ['applause', 'amplification', 'conversation'];

        sourcePostMetrics[sources.CROSS_CHANNEL] = process([
            postDefaults,
            'views',
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes),
            'estimated_impressions',
            'engagement_rate_by_estimated_impression'
        ]);
        sourceMetrics[sources.CROSS_CHANNEL] = process([
            'audience',
            'count',
            'avg_count_per_day',
            'avg_count_per_week',
            'engagement_total',
            'avg_engagement_rate_per_post',
            {
                property: 'avg_engagement_total_per_day',
                dimensions: ['engagement_type']
            },
            'engagement_total_per_post',
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes),
            'video_views',
            'video_views_per_day',
            'video_views_per_post',
            'estimated_impressions',
            'engagement_rate_by_estimated_impression'
        ]);

        const tweetTypes = ['normal', 'retweet', 'reply'];
        engagementTypes = ['applause', 'amplification', 'conversation'];
        sourceMetrics[sources.TWITTER] = process([
            defaults,
            'following',
            'followers_to_following',
            'lifetime_count',
            'lifetime_likes',
            'location',
            'url',
            'listed_count',
            {
                property: 'avg_engagement_total_per_day',
                dimensions: ['engagement_type']
            },

            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes),
            buildDimensionOptions({
                property: 'avg_engagement_total_per_day',
                dimensions: ['engagement_type']
            }, engagementTypes),
            buildDimensionOptions({
                property: 'engagement_total_per_post',
                dimensions: ['engagement_type']
            }, engagementTypes),
            {
                property: 'all_count',
                dimensions: ['tweetType']
            },
            'count',
            buildDimensionOptions({
                property: 'all_count',
                dimensions: ['tweetType']
            }, ['reply', 'retweet']),
            {
                property: 'all_avg_count_per_day',
                dimensions: ['tweetType']
            },
            buildDimensionOptions({
                property: 'avg_count_per_day',
                dimensions: ['tweetType']
            }, tweetTypes),
            {
                property: 'all_avg_count_per_week',
                dimensions: ['tweetType']
            },
            buildDimensionOptions({
                property: 'avg_count_per_week',
                dimensions: ['tweetType']
            }, tweetTypes),
            'overview',
            'overview_size',
            'video_views',
            'video_views_per_day',
            'video_views_per_tweet',
            'engagement_total_tweets_and_replies',
            'impressions',
            'estimated_impressions',
            'engagement_rate_by_estimated_impression'
        ]);

        engagementTypes = ['applause', 'amplification', 'conversation'];
        sourcePostMetrics[sources.TWITTER] = process([
            postDefaults,
            'video_views',
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes),
            'tweetType',
            'impressions',
            'estimated_impressions',
            'engagement_rate_by_estimated_impression'
        ]);

        sourcePostMetrics[sources.TWITTER_INSIGHTS] = process([
            // General
            'media_type',
            'tweetType',
            'presence_reach',

            // Impressions
            'impressions',

            // Engagement
            'engagement_total',
            'engagement_rate_by_impression',
            'engagement_rate_by_presence_reach',
            'social_engagement_total',
            'social_engagement_rate_by_impression',

            // Engagement Details
            'likes',
            'retweets',
            'replies',
            'clicks',
            'video_views'
        ]);

        const twitterAnalyticsPostAggregateMetrics = [
            'count',
            'posts_per_day',
            'posts_per_week',
            'impressions',
            'impressions_per_post',
            'engagement_total',
            'engagement_total_tweets_and_replies',
            'engagement_total_per_post',
            'engagement_rate_by_impression',
            'engagement_rate_by_presence_reach',
            'social_engagement_total',
            'social_engagement_total_tweets_and_replies',
            'social_engagement_total_per_post',
            'social_engagement_rate_by_impression',
            'likes',
            'likes_per_post',
            'retweets',
            'retweets_per_post',
            'replies',
            'replies_per_post',
            'clicks',
            'clicks_per_post',
            'video_views',
            'video_views_per_post'
        ];
        sourcePostAggregateMetrics[sources.TWITTER_INSIGHTS] = process(twitterAnalyticsPostAggregateMetrics);

        const twitterAnalyticsPresenceMetrics = [
            'followers_insights',
            'following_insights',
            'followers_to_following_insights',
            'lifetime_count_insights'
        ];

        const twitterAnalyticsSourceMetrics = twitterAnalyticsPresenceMetrics.concat(_.without(twitterAnalyticsPostAggregateMetrics,
            'count',
            'posts_per_day',
            'posts_per_week',
            'engagement_total',
            'engagement_total_tweets_and_replies',
            'engagement_total_per_post',
            'video_views',
            'impressions'
        )).concat([
            'all_tweets',
            'all_tweets_per_day',
            'all_tweets_per_week',
            'replies_count',
            'replies_per_day',
            'replies_per_week',
            'retweets_count',
            'retweets_per_day',
            'retweets_per_week',
            'normal_tweets_count',
            'normal_tweets_per_day',
            'normal_tweets_per_week',
            'engagement_total_insights',
            'engagement_total_tweets_and_replies_insights',
            'engagement_total_per_post_insights',
            'video_views_insights',
            'impressions_insights'
        ]);
        sourceMetrics[sources.TWITTER_INSIGHTS] = process(twitterAnalyticsSourceMetrics);

        const reactionTypes = [
            'likes',
            'loves',
            'hahas',
            'wows',
            'sads',
            'angrys'
        ];
        engagementTypes = ['amplification', 'conversation'];
        let impressionTypes = ['paid', 'organic', 'viral', 'nonviral'];
        // NOTE: DEPRECATED BY FACEBOOK 2024/09/16
        // const consumptionTypes = ['photo_view', 'video_play', 'link_clicks', 'other_clicks'];
        const payTypes = ['unpaid', 'paid'];
        const ageTypes = [
            '13-17',
            '18-24',
            '25-34',
            '35-44',
            '45-54',
            '55-64',
            '65+'
        ];
        const genderTypes = ['male', 'female', 'unspecified'];
        sourceMetrics[sources.FACEBOOK] = process([
            defaults,
            'count',
            'avg_count_per_day',
            'avg_count_per_week',
            'talking_about',
            'followers_count',
            {
                property: 'avg_engagement_total_per_day',
                dimensions: ['engagement_type']
            },
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes),
            {
                property: 'engagement_total',
                dimensions: ['engagement_type', 'reaction_type'],
                engagement_type: 'applause'
            },
            {
                property: 'avg_engagement_total_per_day',
                dimensions: ['engagement_type', 'reaction_type'],
                engagement_type: 'applause'
            },
            buildDimensionOptions({
                property: 'avg_engagement_total_per_day',
                dimensions: ['engagement_type']
            }, engagementTypes),
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type', 'reaction_type'],
                engagement_type: 'applause'
            }, reactionTypes),
            buildDimensionOptions({
                property: 'avg_engagement_total_per_day',
                dimensions: ['engagement_type', 'reaction_type'],
                engagement_type: 'applause'
            }, reactionTypes),
            'overview',
            'overview_size',
            'likely_promoted',
            'views',
            'post_views',
            'estimated_impressions',
            'engagement_rate_by_estimated_impression'
        ]);

        engagementTypes = ['applause', 'amplification', 'conversation'];
        sourcePostMetrics[sources.FACEBOOK] = process([
            postDefaults,
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes),
            'likes',
            'loves',
            'hahas',
            'wows',
            'sads',
            'angrys',
            'promoted_likelyhood',
            'views',
            'post_views',
            'estimated_impressions',
            'engagement_rate_by_estimated_impression'
        ]);

        sourcePostMetrics[sources.FACEBOOK_INSIGHTS] = process([
            // general
            'media_type',
            'admin_creator_name',
            'boosted_post_total_spend',

            // reach/impressions
            'reach',
            'paid_reach',
            'organic_reach',
            'viral_reach',
            'nonviral_reach',
            'post_fan_reach',
            'post_fan_reach_rate',
            'impressions',
            'paid_impressions',
            'organic_impressions',
            // viral_impressions / nonviral_impressions removed from picker per CMPTE-403
            // (no Meta recovery path). Saved widgets referencing them still render with the
            // [Deprecated] tooltip via the deprecationReason set in public/metrics/facebook.js.
            'engaged_users_other',
            'presence_reach',

            // engagement
            'social_engagement_total',
            'post_only_social_engagement_total',
            'engagement_total',
            'organic_engagement_total',
            'paid_engagement_total',
            'reactions',

            // these are post+shares
            'post_only_likes',
            'post_only_loves',
            'post_only_hahas',
            'post_only_wows',
            'post_only_sads',
            'post_only_angrys',

            // these are post-only metrics
            'likes',
            'loves',
            'hahas',
            'wows',
            'sads',
            'angrys',

            'negative_feedback',
            'negative_feedback_unique',
            'fan_post_impressions',
            'paid_fan_impressions',
            'paid_fan_reach',
            'video_viewers',
            'organic_video_viewers',
            'paid_video_viewers',
            'video_view_length',
            'organic_video_view_length',
            'paid_video_view_length',
            'organic_reactions',
            'paid_reactions',
            'post_only_reactions',
            'comments',
            'organic_comments',
            'paid_comments',
            'post_only_comments',
            'shares',
            'organic_shares',
            'paid_shares',
            'post_only_shares',
            'post_consumptions',
            'link_clicks',
            'photo_views',
            'video_plays',
            'other_clicks',
            'paid_post_consumptions',
            'paid_link_clicks',
            'paid_photo_views',
            'paid_video_plays',
            'paid_other_clicks',

            // engagement rate details
            'insights_engagement_rate',
            'social_engagement_rate_by_reach',
            'social_engagement_rate_by_reach_paid',
            'social_engagement_rate_by_reach_organic',
            'social_engagement_rate_by_impression',
            'paid_social_engagement_rate_by_impression',
            'organic_social_engagement_rate_by_impression',
            'engagement_rate_by_reach',
            'engagement_rate_by_impression',
            'engagement_rate_by_presence_reach',
            'social_engagement_rate_by_presence_reach',

            // Video view details
            'live_audience_count',
            'post_video_length',
            'post_video_avg_time_watched',
            'avg_watch_length_pct_viewed',
            'video_view_rate',
            'post_video_views',
            'post_video_views_organic',
            'post_video_views_paid',
            'post_video_complete_views_30s',
            'post_video_complete_views_30s_organic',
            'post_video_complete_views_30s_paid',
            'post_video_views_10s',
            'post_video_views_10s_organic',
            'post_video_views_10s_paid',
            'views_to_95_pct',
            'post_video_complete_views_organic',
            'post_video_complete_views_paid',
            '30_second_view_rate',
            'organic_30_second_view_rate',
            'paid_30_second_view_rate',
            '95_pct_view_rate',
            '95_pct_view_rate_organic',
            '95_pct_view_rate_paid'


            // NOTE: DEPRECATED BY FACEBOOK 2024/09/16
            //
            // 'post_engaged_users'
            // 'post_engaged_fan'
        ]);

        const facebookInsightsPostAggregateMetrics = [
            'count',
            'posts_per_day',
            'posts_per_week',
            'reach_per_post',
            'reach_per_reel',
            'paid_reach_per_post',
            'organic_reach_per_post',
            'viral_reach_per_post',
            'nonviral_reach_per_post',
            'fan_reach_per_post',
            'fan_reach_rate_per_post',
            'impressions_per_post',
            'paid_impressions_per_post',
            'organic_impressions_per_post',
            // viral_impressions_per_post / nonviral_impressions_per_post removed from picker
            // per CMPTE-403 (no Meta recovery path). See public/metrics/facebook.js.
            'impressions',
            'paid_impressions',
            'organic_impressions',
            // viral_impressions / nonviral_impressions removed from picker per CMPTE-403.
            'engaged_users_per_post',
            'engaged_fans_per_post',
            'engaged_others_per_post',
            'total_post_consumptions',
            'paid_post_consumptions',
            'post_consumptions_per_post',
            'paid_post_consumptions_per_post',
            'total_link_clicks',
            'paid_link_clicks',
            'link_clicks_per_post',
            'paid_link_clicks_per_post',
            'total_photo_views',
            'paid_photo_views',
            'photo_views_per_post',
            'paid_photo_views_per_post',
            'total_video_plays',
            'paid_video_plays',
            'video_plays_per_post',
            'paid_video_plays_per_post',
            'total_other_clicks',
            'paid_other_clicks',
            'other_clicks_per_post',
            'paid_other_clicks_per_post',
            'social_engagement_total',
            'paid_social_engagement_total',
            'organic_social_engagement_total',
            'post_only_social_engagement_total',
            'social_engagement_total_per_post',
            'paid_social_engagement_total_per_post',
            'organic_social_engagement_total_per_post',
            'post_only_social_engagement_total_per_post',
            'engagement_total',
            'engagement_total_per_post',
            'facebook_engagement_rate',
            'social_engagement_rate_by_reach',
            'paid_social_engagement_rate_by_reach',
            'organic_social_engagement_rate_by_reach',
            'social_engagement_rate_by_impression',
            'paid_social_engagement_rate_by_impression',
            'organic_social_engagement_rate_by_impression',
            'engagement_rate_by_impression',
            'engagement_rate_by_reach',
            'social_engagement_rate_by_presence_reach',
            'engagement_rate_by_presence_reach',
            'likes',
            'likes_per_post',
            'loves',
            'loves_per_post',
            'hahas',
            'hahas_per_post',
            'wows',
            'wows_per_post',
            'sads',
            'sads_per_post',
            'angrys',
            'angrys_per_post',
            'negative_feedback',
            'negative_feedback_per_post',
            'negative_feedback_unique_per_post',
            'fan_post_impressions',
            'fan_impressions_per_post',
            'paid_fan_impressions',
            'paid_fan_impressions_per_post',
            'paid_fan_reach_per_post',
            'video_viewers_per_post',
            'organic_video_viewers_per_post',
            'paid_video_viewers_per_post',
            'video_view_length',
            'reel_view_length',
            'video_view_length_per_post',
            'organic_video_view_length',
            'organic_video_view_length_per_post',
            'paid_video_view_length',
            'paid_video_view_length_per_post',
            'reactions',
            'paid_reactions',
            'organic_reactions',
            'post_only_reactions',
            'reactions_per_post',
            'paid_reactions_per_post',
            'organic_reactions_per_post',
            'post_only_reactions_per_post',
            'total_comments',
            'paid_comments',
            'organic_comments',
            'post_only_comments',
            'comments_per_post',
            'paid_comments_per_post',
            'organic_comments_per_post',
            'post_only_comments_per_post',
            'total_shares',
            'paid_shares',
            'organic_shares',
            'post_only_shares',
            'shares_per_post',
            'paid_shares_per_post',
            'organic_shares_per_post',
            'post_only_shares_per_post',
            'video_count',
            'reel_count',
            'reel_and_video_count',
            'live_audience_count_per_post',
            'post_video_length_per_post',
            'post_video_avg_time_watched_per_post',
            'post_reel_avg_time_watched_per_post',
            'avg_watch_length_pct_viewed_per_post',
            'video_view_rate_per_post',
            'post_video_views',
            'post_reel_views',
            'organic_post_video_views',
            'paid_post_video_views',
            'post_video_views_per_post',
            'organic_post_video_views_per_post',
            'paid_post_video_views_per_post',
            'post_video_complete_views',
            'organic_post_video_complete_views',
            'paid_post_video_complete_views',
            'post_video_complete_views_per_post',
            'organic_post_video_complete_views_per_post',
            'paid_post_video_complete_views_per_post',
            'reel_and_video_view_length',
            'post_reel_and_video_avg_time_watched_per_post',
            'post_reel_and_video_views'
        ];
        sourcePostAggregateMetrics[sources.FACEBOOK_INSIGHTS] = process(facebookInsightsPostAggregateMetrics);

        const facebookInsightsPresenceMetrics = [
            'impressions',
            buildDimensionOptions({
                property: 'impressions',
                dimensions: ['impression_type']
            }, impressionTypes),
            'unique_impressions',
            buildDimensionOptions({
                property: 'impressions_per_day',
                dimensions: ['impression_type']
            }, impressionTypes),
            'average_daily_page_impressions',
            buildDimensionOptions({
                property: 'unique_impressions',
                dimensions: ['impression_type']
            }, impressionTypes),
            buildDimensionOptions({
                property: 'unique_impressions',
                dimensions: ['gender', 'age_range']
            }, genderTypes, ageTypes),
            'page_engagement_rate',

            // This is not the same thing as presence_reach; this is going to be the regional number, while presence_reach is the global number.
            'page_fans',
            buildDimensionOptions({
                property: 'page_fans',
                dimensions: ['gender']
            }, genderTypes),
            buildDimensionOptions({
                property: 'page_fans',
                dimensions: ['gender', 'age_range']
            }, genderTypes, ageTypes),
            'page_fan_adds',
            buildDimensionOptions({
                property: 'page_fan_adds',
                dimensions: ['pay_type']
            }, payTypes),
            'unique_page_fan_adds',
            'page_fan_removes',
            'unique_page_fan_removes',

            'page_views_total',
            'page_total_actions',
            'average_daily_page_total_actions',
            'average_daily_page_engaged_users',
            'average_daily_page_posts_impressions_unique',
            'page_posts_impressions',
            'average_daily_page_posts_impressions',
            'average_daily_page_posts_impressions_paid_unique',
            'average_daily_page_posts_impressions_viral_unique',
            'average_daily_page_posts_impressions_nonviral_unique',
            'page_posts_impressions_paid',
            'page_posts_impressions_viral',
            'page_posts_impressions_nonviral',
            'average_daily_page_posts_impressions_paid',
            'average_daily_page_posts_impressions_organic',
            'average_daily_page_posts_impressions_viral',
            'average_daily_page_posts_impressions_nonviral',

            'page_video_views',
            'page_video_views_organic',
            'page_video_views_paid',
            'page_video_views_per_day',
            'page_video_views_organic_per_day',
            'page_video_views_paid_per_day',
            'page_video_repeat_views',
            'page_video_views_unique',
            'page_video_views_10s',
            'page_video_views_10s_organic',
            'page_video_views_10s_paid',
            'page_video_views_10s_repeat',
            'page_video_views_10s_unique'

            // NOTE: DEPRECATED BY FACEBOOK 2024/09/16
            //
            // 'phone_call_clicks',
            // 'website_clicks',
            // 'direction_clicks'
            //
            // 'consumptions'
            // buildDimensionOptions({
            //     property: 'consumptions',
            //     dimensions: ['consumption_type']
            // }, consumptionTypes)
            // 'unique_consumptions'
            // buildDimensionOptions({
            //     property: 'unique_consumptions',
            //     dimensions: ['consumption_type']
            // }, consumptionTypes)
            //
            // 'page_negative_feedback'
            // 'page_negative_feedback_unique'
            //
            // buildDimensionOptions({
            //     property: 'unique_impressions',
            //     dimensions: ['gender']
            // }, genderTypes)
            //
            // 'page_posts_impressions_organic',
            // 'average_daily_page_posts_impressions_organic_unique'
            //
            // 'average_daily_page_views_total'
        ];
        const facebookInsightsSourceMetrics = facebookInsightsPresenceMetrics.concat(_.without(facebookInsightsPostAggregateMetrics,
            'count',
            'posts_per_day',
            'posts_per_week',
            'impressions',

            'engagement_total',
            'engagement_total_per_post'
        )).concat([
            'count_insights',
            'posts_per_day_insights',
            'posts_per_week_insights',
            'impressions_insights',

            'engagement_total_insights',
            'engagement_total_per_post_insights'
        ]);

        sourceMetrics[sources.FACEBOOK_INSIGHTS] = process(facebookInsightsSourceMetrics);

        sourceMetrics[sources.FACEBOOK_ADS] = process([
            'account_id',
            'account_name',

            'action_values_offsite_conversion',
            'action_values_offsite_conversion__fb_pixel_view_content',
            'action_values_offsite_conversion__fb_pixel_search',
            'action_values_offsite_conversion__fb_pixel_add_to_cart',
            'action_values_offsite_conversion__fb_pixel_add_to_wishlist',
            'action_values_offsite_conversion__fb_pixel_initiate_checkout',
            'action_values_offsite_conversion__fb_pixel_add_payment_info',
            'action_values_offsite_conversion__fb_pixel_purchase',
            'action_values_offsite_conversion__fb_pixel_lead',
            'action_values_offsite_conversion__fb_pixel_complete_registration',

            'actions_comment',
            'actions_landing_page_view',
            'actions_leadgen_grouped',
            'actions_like',
            'actions_link_click',
            'actions_post_reaction',
            'actions_page_engagement',
            'actions_post_engagement',
            'actions_offsite_conversion',
            'actions_offsite_conversion__fb_pixel_view_content',
            'actions_offsite_conversion__fb_pixel_search',
            'actions_offsite_conversion__fb_pixel_add_to_cart',
            'actions_offsite_conversion__fb_pixel_add_to_wishlist',
            'actions_offsite_conversion__fb_pixel_initiate_checkout',
            'actions_offsite_conversion__fb_pixel_add_payment_info',
            'actions_offsite_conversion__fb_pixel_purchase',
            'actions_offsite_conversion__fb_pixel_lead',
            'actions_offsite_conversion__fb_pixel_complete_registration',
            'actions_onsite_conversion__messaging_conversation_started_7d',
            'actions_video_view',

            'ad_id',
            'ad_name',
            'ad_body',
            'ad_title',
            'adset_id',
            'adset_name',
            'buying_type',
            'campaign_id',
            'campaign_name',
            'canvas_avg_view_percent',
            'canvas_avg_view_time',

            'start_time',
            'stop_time',
            'lifetime_budget',

            // commented out until we can look at some data from folks using Facebook Canvas.
            // 'canvas_component_avg_pct_view',

            'clicks',

            // fb returns this as an array of actions, though video_view is the only thing in said array.
            // I kept the naming convention from other actions so I didn't have to special case.
            'cost_per_thruplay_video_view',

            'cost_per_action_type_comment',
            'cost_per_action_type_landing_page_view',
            'cost_per_action_type_leadgen_grouped',
            'cost_per_action_type_like',
            'cost_per_action_type_link_click',
            'cost_per_action_type_post_reaction',
            'cost_per_action_type_page_engagement',
            'cost_per_action_type_post_engagement',
            'cost_per_action_type_offsite_conversion',
            'cost_per_action_type_offsite_conversion__fb_pixel_view_content',
            'cost_per_action_type_offsite_conversion__fb_pixel_search',
            'cost_per_action_type_offsite_conversion__fb_pixel_add_to_cart',
            'cost_per_action_type_offsite_conversion__fb_pixel_add_to_wishlist',
            'cost_per_action_type_offsite_conversion__fb_pixel_initiate_checkout',
            'cost_per_action_type_offsite_conversion__fb_pixel_add_payment_info',
            'cost_per_action_type_offsite_conversion__fb_pixel_purchase',
            'cost_per_action_type_offsite_conversion__fb_pixel_lead',
            'cost_per_action_type_offsite_conversion__fb_pixel_complete_registration',
            'cost_per_action_type_onsite_conversion__messaging_conversation_started_7d',
            'cost_per_action_type_video_view',

            'cost_per_estimated_ad_recallers',
            'cost_per_inline_link_click',
            'cost_per_inline_post_engagement',

            'cost_per_unique_action_type_comment',
            'cost_per_unique_action_type_landing_page_view',
            'cost_per_unique_action_type_leadgen_grouped',
            'cost_per_unique_action_type_like',
            'cost_per_unique_action_type_link_click',
            'cost_per_unique_action_type_post_reaction',
            'cost_per_unique_action_type_page_engagement',
            'cost_per_unique_action_type_post_engagement',
            'cost_per_unique_action_type_offsite_conversion',
            'cost_per_unique_action_type_offsite_conversion__fb_pixel_view_content',
            'cost_per_unique_action_type_offsite_conversion__fb_pixel_search',
            'cost_per_unique_action_type_offsite_conversion__fb_pixel_add_to_cart',
            'cost_per_unique_action_type_offsite_conversion__fb_pixel_add_to_wishlist',
            'cost_per_unique_action_type_offsite_conversion__fb_pixel_initiate_checkout',
            'cost_per_unique_action_type_offsite_conversion__fb_pixel_add_payment_info',
            'cost_per_unique_action_type_offsite_conversion__fb_pixel_purchase',
            'cost_per_unique_action_type_offsite_conversion__fb_pixel_lead',
            'cost_per_unique_action_type_offsite_conversion__fb_pixel_complete_registration',
            'cost_per_unique_action_type_onsite_conversion__messaging_conversation_started_7d',
            'cost_per_unique_action_type_video_view',

            'cost_per_unique_click',
            'cost_per_unique_inline_link_click',
            'cpc',
            'cpm',
            'cpp',
            'ctr',
            'date_start',
            'date_stop',
            'engagement_rate',
            'estimated_ad_recall_rate',
            'estimated_ad_recallers',
            'frequency',
            'impressions',
            'inline_link_click_ctr',
            'inline_link_clicks',
            'inline_post_engagement',
            'objective',
            'place_page_name',
            'reach',
            'social_spend',
            'spend',

            'unique_actions_comment',
            'unique_actions_landing_page_view',
            'unique_actions_leadgen_grouped',
            'unique_actions_like',
            'unique_actions_link_click',
            'unique_actions_post_reaction',
            'unique_actions_page_engagement',
            'unique_actions_post_engagement',
            'unique_actions_offsite_conversion',
            'unique_actions_offsite_conversion__fb_pixel_view_content',
            'unique_actions_offsite_conversion__fb_pixel_search',
            'unique_actions_offsite_conversion__fb_pixel_add_to_cart',
            'unique_actions_offsite_conversion__fb_pixel_add_to_wishlist',
            'unique_actions_offsite_conversion__fb_pixel_initiate_checkout',
            'unique_actions_offsite_conversion__fb_pixel_add_payment_info',
            'unique_actions_offsite_conversion__fb_pixel_purchase',
            'unique_actions_offsite_conversion__fb_pixel_lead',
            'unique_actions_offsite_conversion__fb_pixel_complete_registration',
            'unique_actions_onsite_conversion__messaging_conversation_started_7d',
            'unique_actions_video_view',

            'unique_clicks',
            'unique_ctr',
            'unique_inline_link_click_ctr',
            'unique_inline_link_clicks',
            'unique_link_clicks_ctr',

            // fb returns this as an array of actions, though video_view is the only thing in said array.
            // I kept the naming convention from other actions so I didn't have to special case.
            'video_thruplay_watched_actions_video_view',
            'video_30_sec_watched_actions_video_view',
            'video_avg_time_watched_actions_video_view',
            'video_p100_watched_actions_video_view',
            'video_p25_watched_actions_video_view',
            'video_p50_watched_actions_video_view',
            'video_p75_watched_actions_video_view',

            'purchase_roas_omni_purchase',
            'website_ctr_link_click',
            'cost_per_result',
            'results'
        ]);

        engagementTypes = ['applause', 'conversation'];
        sourceMetrics[sources.YOUTUBE] = process([
            defaults,
            'count',
            'avg_count_per_day',
            'avg_count_per_week',
            {
                property: 'avg_engagement_total_per_day',
                dimensions: ['engagement_type']
            },
            'page_views',
            'views',
            'avg_views_per_day',
            'overview',
            'overview_size',
            'title',
            'title_size',
            'keywords',
            'videos',
            'engagement_total_per_view',
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes),
            buildDimensionOptions({
                property: 'avg_engagement_total_per_day',
                dimensions: ['engagement_type']
            }, engagementTypes),
            'estimated_impressions',
            'engagement_rate_by_estimated_impression'
        ]);

        engagementTypes = ['applause', 'conversation'];
        sourcePostMetrics[sources.YOUTUBE] = process([
            postDefaults,
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes),
            'views',
            'engagement_total_per_view',
            'estimated_impressions',
            'engagement_rate_by_estimated_impression'
        ]);

        engagementTypes = ['applause', 'conversation'];
        sourceMetrics[sources.INSTAGRAM] = process([
            defaults,
            'count',
            'avg_count_per_day',
            'avg_count_per_week',
            'following',
            'followers_to_following',
            'lifetime_count',
            'overview',
            'overview_size',
            'display_name',
            'display_name_size',
            'average_comments_per_post',
            'average_likes_per_post',
            {
                property: 'avg_engagement_total_per_day',
                dimensions: ['engagement_type']
            },
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes),
            buildDimensionOptions({
                property: 'avg_engagement_total_per_day',
                dimensions: ['engagement_type']
            }, engagementTypes),
            'estimated_impressions',
            'engagement_rate_by_estimated_impression'
        ]);

        engagementTypes = ['applause', 'conversation'];
        sourcePostMetrics[sources.INSTAGRAM] = process([
            postDefaults,
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes),
            'estimated_impressions',
            'engagement_rate_by_estimated_impression'
        ]);

        function getInstagramPaidEngagementMetrics(properties, options) {
            const hasPaidEngagement = _.get(options, ['hasPaidEngagement'], false);
            const metrics = _.reduce(properties, instagramPaidMetricUtils().instagramPaidEngagementPropertyReducer(hasPaidEngagement), []);
            return process(metrics);
        }

        sourcePostMetrics[sources.INSTAGRAM_INSIGHTS] = _.partial(getInstagramPaidEngagementMetrics, [
            'media_type',
            'reach',
            'engagement_total',
            'engagement_rate_by_reach',
            'engagement_rate_by_impression',
            'reach_rate',
            'likes',
            'comments',
            'saves',
            'shares',
            'impressions',
            'presence_reach',
            'video_views',
            'video_view_rate',
            'video_views_per_user',
            'total_carousel_children',
            'num_photo_children',
            'num_video_children',
            'link_clicks',
            'follows',
            'profile_visits',
            'profile_activity_total',
            'profile_activity_bio_link_clicked',
            'profile_activity_not_bio_link_clicked',
            'social_engagement_total',
            'social_engagement_rate_by_reach',
            'social_engagement_rate_by_impression',
            'engagement_rate_by_presence_reach'
        ]);

        sourcePostAggregateMetrics[sources.INSTAGRAM_INSIGHTS] = _.partial(getInstagramPaidEngagementMetrics, [
            'count',
            'likes',
            'likes_per_post',
            'comments',
            'comments_per_post',
            'saves',
            'saves_per_post',
            'shares',
            'shares_per_post',
            'video_view_rate',
            'follows',
            'profile_visits',
            'profile_activity_total',
            'profile_activity_bio_link_clicked',
            'profile_activity_not_bio_link_clicked',

            // There are no paid/organic variants of this engagement rate
            'engagement_rate_by_presence_reach',

            // Each of these metrics will be expanded to paid + organic variants if the user has the correct access.
            'engagement_total',
            // 'organic_engagement_total',
            // 'paid_engagement_total',

            'engagement_rate_by_reach',
            // 'organic_engagement_rate_by_reach',
            // 'paid_engagement_rate_by_reach',

            'engagement_rate_by_impression',
            // 'organic_engagement_rate_by_impression',
            // 'paid_engagement_rate_by_impression',

            'engagement_total_per_post',
            // 'organic_engagement_total_per_post',
            // 'paid_engagement_total_per_post',

            'reach_per_post',
            // 'organic_reach_per_post',
            // 'paid_reach_per_post',

            'reach_rate_per_post',
            // 'organic_reach_rate_per_post',
            // 'paid_reach_rate_per_post',

            'impressions',
            // 'organic_impressions',
            // 'paid_impressions',

            'impressions_per_post',
            // 'organic_impressions_per_post',
            // 'paid_impressions_per_post'

            'social_engagement_total',
            // 'organic_social_engagement_total',
            // 'paid_social_engagement_total',

            'social_engagement_rate_by_reach',
            // Note: Names inverted for consistency with Facebook metrics.
            // 'social_engagement_rate_by_reach_organic',
            // 'social_engagement_rate_by_reach_paid',

            'social_engagement_rate_by_impression',
            // 'organic_social_engagement_rate_by_impression',
            // 'paid_social_engagement_rate_by_impression',

            'video_views',
            // 'organic_video_views'
            // 'paid_video_views'

            'video_views_per_post'
            // 'organic_video_views_per_post'
            // 'paid_video_views_per_post'
        ]);

        sourceMetrics[sources.INSTAGRAM_INSIGHTS] = process([

            // audience
            'new_follower_count',
            'followers_count',
            'following_insights',
            'followers_to_following_insights',

            buildDimensionOptions({
                property: 'audience_gender_age',
                dimensions: ['gender']
            }, genderTypes),
            buildDimensionOptions({
                property: 'audience_gender_age',
                dimensions: ['gender', 'age_range']
            }, genderTypes, ageTypes),

            // page reach, etc
            'page_impressions',
            'page_impressions_per_day',

            'page_reach_per_day',
            'page_reach_per_day_followers',
            'page_reach_per_day_non_followers',
            'page_reach_per_day_from_ads',
            'page_reach_per_day_from_carousels',
            'page_reach_per_day_from_posts',
            'page_reach_per_day_from_reels',
            'page_reach_per_day_from_stories',

            'page_accounts_engaged_per_day',
            'page_interactions',
            'page_story_replies',

            // Profile Engagements
            'profile_views',
            'profile_links_taps',

            'profile_engagements',
            'email_contacts',
            'get_directions_clicks',
            'phone_call_clicks',
            'text_message_clicks',
            'website_clicks',
            'paid_link_clicks',

            // page interactions
            'page_likes',
            'page_likes_from_ads',
            'page_likes_from_carousels',
            'page_likes_from_posts',
            'page_likes_from_reels',

            'page_comments',
            'page_comments_from_ads',
            'page_comments_from_carousels',
            'page_comments_from_posts',
            'page_comments_from_reels',

            'page_shares',
            'page_shares_from_ads',
            'page_shares_from_carousels',
            'page_shares_from_posts',
            'page_shares_from_reels',
            'page_shares_from_stories',

            'page_saves',
            'page_saves_from_ads',
            'page_saves_from_carousels',
            'page_saves_from_posts',
            'page_saves_from_reels',

            // stories
            'days_with_story',
            'stories_per_day',
            'total_num_stories',
            'story_replies',
            'replies_per_story',
            'taps_forward',
            'taps_forward_per_story',
            'average_taps_forward_rate',
            'taps_back',
            'taps_back_per_story',
            'average_taps_back_rate',
            'average_full_view_rate',
            'exits',
            'exit_rate_per_story',
            'exits_per_story',
            'completions',
            'completions_per_story',
            'completion_rate_per_story',
            'stories_retention_rate',
            'story_impressions',
            'impressions_per_story',
            'story_impressions_per_day',
            'reach_per_story',
            'average_reach_rate',
            'story_max_reach_rate',
            'story_max_reach_per_day',
            'swipes_forward',
            'story_shares',
            'swipes_forward_per_story',
            'shares_per_story',

            // post activity
            'daily_posts',
            'organic_daily_posts',
            'paid_daily_posts',
            'posts_per_day',
            'posts_per_week',
            'lifetime_count_insights',

            // post engagements
            'likes',
            'organic_likes',
            'paid_likes',
            'likes_per_post',
            'organic_likes_per_post',
            'paid_likes_per_post',

            'comments',
            'organic_comments',
            'paid_comments',
            'comments_per_post',
            'organic_comments_per_post',
            'paid_comments_per_post',

            'saves',
            'organic_saves',
            'paid_saves',
            'saves_per_post',
            'organic_saves_per_post',
            'paid_saves_per_post',

            'shares',
            'organic_shares',
            'paid_shares',
            'shares_per_post',
            'organic_shares_per_post',
            'paid_shares_per_post',

            'engagement_total_insights',
            'organic_engagement_total',
            'paid_engagement_total',

            // NOTE there are no paid/organic variants of this engagement rate
            'engagement_rate_by_presence_reach',

            'engagement_total_per_post_insights',
            'organic_engagement_total_per_post',
            'paid_engagement_total_per_post',

            'organic_engagement_rate_by_reach',
            'paid_engagement_rate_by_reach',

            'engagement_rate_by_impression',
            'organic_engagement_rate_by_impression',
            'paid_engagement_rate_by_impression',

            'video_views',
            'organic_video_views',
            'paid_video_views',

            'video_views_including_carousels',
            'organic_video_views_including_carousels',
            'paid_video_views_including_carousels',

            'video_views_per_post',
            'organic_video_views_per_post',
            'paid_video_views_per_post',

            'video_view_rate',
            'organic_video_view_rate',
            'paid_video_view_rate',

            'organic_social_engagement_total',
            'paid_social_engagement_total',
            'social_engagement_total',
            'organic_social_engagement_rate_by_impression',
            'paid_social_engagement_rate_by_impression',
            'social_engagement_rate_by_impression',
            'social_engagement_rate_by_reach_organic',
            'social_engagement_rate_by_reach_paid',

            // post reach/impressions
            'post_impressions',
            'organic_post_impressions',
            'paid_post_impressions',

            'impressions_per_post',
            'organic_impressions_per_post',
            'paid_impressions_per_post',

            'organic_reach_per_post',
            'paid_reach_per_post',

            'organic_reach_rate_per_post',
            'paid_reach_rate_per_post'
        ]);

        // NOTE metrics for story frames
        sourceStoryMetrics[sources.INSTAGRAM_INSIGHTS] = process([
            'order_details',
            'exits',
            'exit_rate',
            'full_view_rate',
            'impressions',
            'reach',
            'replies',
            'taps_forward',
            'taps_back',
            'completion_rate',
            'taps_forward_rate',
            'reach_rate',
            'swipes_forward',
            'shares',
            'follows',
            'profile_visits',
            'profile_activity_total',
            'profile_activity_bio_link_clicked',
            'profile_activity_not_bio_link_clicked'
        ]);

        // NOTE metrics for story days
        sourceStoryDayMetrics[sources.INSTAGRAM_INSIGHTS] = process([
            'stories_retention_rate',
            'max_reach',
            'max_reach_rate',
            'num_stories',
            'replies',
            'taps_back',
            'taps_forward',
            'exits',
            'story_impressions',
            'impressions_per_story',
            'reach_per_story',
            'swipes_forward',
            'shares',
            'follows',
            'profile_visits',
            'profile_activity_total',
            'profile_activity_bio_link_clicked',
            'profile_activity_not_bio_link_clicked'
        ]);

        // NOTE metrics for story frame aggregates over arbitrary time periods; these are used in the IG Stories UI
        sourceStoryAggregateMetrics[sources.INSTAGRAM_INSIGHTS] = process([
            'count',
            'reach_per_story',
            'average_reach_rate',
            'impressions_per_story',
            'average_completion_rate',
            'replies_per_story',
            'exits_per_story',
            'average_full_view_rate',
            'taps_forward_per_story',
            'average_taps_forward_rate',
            'exit_rate_per_story',
            'taps_back_per_story',
            'average_taps_back_rate',
            'swipes_forward',
            'story_shares',
            'story_follows',
            'story_profile_visits',
            'story_profile_activity_total',
            'story_profile_activity_bio_link_clicked',
            'story_profile_activity_not_bio_link_clicked',
            'swipes_forward_per_story',
            'shares_per_story',
            'follows_per_story',
            'profile_visits_per_story',
            'profile_activity_total_per_story',
            'profile_activity_bio_link_clicked_per_story',
            'profile_activity_not_bio_link_clicked_per_story'
        ]);

        impressionTypes = ['organic', 'paid'];
        engagementTypes = ['applause', 'amplification', 'conversation', 'action'];
        const jobFunctions = _.map(linkedInJobFunctionMap, function (v) {
            return v.code || 'none';
        });

        sourcePostMetrics[sources.LINKEDIN] = process([
            'media_type',
            'presence_reach',
            'impressions',
            'engagement_total',
            'engagement_rate_by_impression',
            'engagement_rate_by_presence_reach',
            'social_engagement_total',
            'social_engagement_rate_by_impression',
            'social_engagement_rate_by_presence_reach',
            'likes',
            'comments',
            'shares',
            'clicks',
            'video_views',
            'video_viewers',
            'video_watched_minutes'
        ]);

        const linkedInPostAggregateMetrics = [
            'count',
            'posts_per_day',
            'posts_per_week',
            'engagement_total',
            'engagement_rate_by_impression',
            'engagement_rate_by_presence_reach',
            'social_engagement_rate_by_impression',
            'social_engagement_rate_by_presence_reach',
            'engagement_total_per_post',
            'social_engagement_total',
            'social_engagement_total_per_post',
            'likes',
            'likes_per_post',
            'comments',
            'comments_per_post',
            'shares',
            'shares_per_post',
            'clicks',
            'clicks_per_post',
            'video_views',
            'video_views_per_post',
            'video_viewers_per_post',
            'video_watched_minutes',
            'video_watched_minutes_per_post',
            'impressions',
            'impressions_per_post'
        ];

        sourcePostAggregateMetrics[sources.LINKEDIN] = process(linkedInPostAggregateMetrics);

        const linkedInPresenceMetrics = [
            buildDimensionOptions({
                property: 'presence_reach_adds',
                dimensions: ['impression_type']
            }, impressionTypes),
            'presence_reach',
            buildDimensionOptions({
                property: 'presence_reach',
                dimensions: ['job_function']
            }, jobFunctions),
            'unique_post_visitors',
            'post_impressions',
            'post_impressions_per_day',
            'overview_page_views',
            'overview_page_unique_views',
            'page_engagement_total',
            'page_engagement_rate',
            buildDimensionOptions({
                property: 'page_engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes)
        ];

        const linkedInSourceMetrics = linkedInPresenceMetrics.concat(_.without(linkedInPostAggregateMetrics,
            'engagement_total',
            'likes',
            'likes_per_post',
            'comments',
            'comments_per_post',
            'shares',
            'shares_per_post',
            'clicks',
            'clicks_per_post'
        )).concat([
            'engagement_total',
            buildDimensionOptions({
                property: 'engagement_total_per_post',
                dimensions: ['engagement_type']
            }, engagementTypes),
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes)
        ]);
        sourceMetrics[sources.LINKEDIN] = process(linkedInSourceMetrics);

        sourceMetrics[sources.WEB] = process([
            'title',
            'title_size',
            'overview',
            'overview_size',
            'overview_size_rating',
            'keywords'
        ]);

        engagementTypes = ['applause', 'amplification', 'conversation'];
        sourcePostMetrics[sources.TIKTOK] = process([
            postDefaults,
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes),
            'views',
            'engagement_total_per_view',
            'estimated_impressions',
            'engagement_rate_by_estimated_impression'
        ]);

        sourceMetrics[sources.TIKTOK] = process([
            'audience',
            'count',
            'avg_count_per_day',
            'avg_count_per_week',
            {
                property: 'engagement_total',
                dimensions: ['engagement_type']
            },
            'avg_engagement_rate_per_post',
            'overview',
            'overview_size',
            {
                property: 'avg_engagement_total_per_day',
                dimensions: ['engagement_type']
            },
            'engagement_total_per_post',
            buildDimensionOptions({
                property: 'engagement_total',
                dimensions: ['engagement_type']
            }, engagementTypes),
            'views',
            'views_per_post',
            'avg_views_per_day',
            'engagement_total_per_view',
            'views_per_follower',
            'estimated_impressions',
            'engagement_rate_by_estimated_impression'
        ]);

        sourceMetrics[sources.TIKTOK_INSIGHTS] = process([
            'comments_insights',
            'likes_insights',
            'shares_insights',
            'engagement_total_insights',
            'profile_views',
            'video_views_insights'
        ]);

        sourcePostMetrics[sources.TIKTOK_INSIGHTS] = process([
            // General
            'media_type',
            'presence_reach',

            // Impressions
            'impressions',

            // Engagement
            'engagement_total',
            'engagement_rate_by_impression',
            'engagement_rate_by_presence_reach',

            // Engagement Details
            'likes',
            'comments',
            'shares',
            'video_views'
        ]);

        const tiktokInsightsPostAggregateMetrics = [
            'count',
            'posts_per_day',
            'posts_per_week',
            'reach_per_post',
            'impressions_per_post',
            'impressions',
            'social_engagement_total',
            'social_engagement_total_per_post',
            'engagement_total',
            'engagement_total_per_post',
            'social_engagement_rate_by_reach',
            'social_engagement_rate_by_impression',
            'engagement_rate_by_impression',
            'engagement_rate_by_reach',
            'social_engagement_rate_by_presence_reach',
            'engagement_rate_by_presence_reach',
            'video_view_length',
            'video_view_length_per_post',
            'total_comments',
            'comments_per_post',
            'total_shares',
            'shares_per_post',
            'post_video_length_per_post'
        ];

        sourcePostAggregateMetrics[sources.TIKTOK_INSIGHTS] = process(tiktokInsightsPostAggregateMetrics);

        function process(metrics) {
            return _.map(_.flatten(metrics), function (metric) {
                if (_.isString(metric)) {
                    metric = {
                        property: metric
                    };
                }

                return metric;
            });
        }

        // Builds expanded dimension definitions
        function buildDimensionOptions(metric) {
            const dimensionValues = Array.prototype.slice.call(arguments, 1);

            let mapping = [{}];
            _.each(dimensionValues, function (array, i) {
                const dimensionName = metric.dimensions[metric.dimensions.length - dimensionValues.length + i];
                mapping = _.flatten(_.map(array, function (value) {
                    return _.map(mapping, function (map) {
                        map = _.clone(map);
                        map[dimensionName] = value;
                        return map;
                    });
                }));
            });

            return _.map(mapping, function (map) {
                return _.defaults(map, metric);
            });
        }

        function metricRetrievalFunction(mapping, source, options) {
            const metrics = mapping[source];
            if (!_.isFunction(metrics)) {
                return (metrics || []);
            }
            return metrics(options);
        }

        const exported = {
            forSource(source, options) {
                return metricRetrievalFunction(sourceMetrics, source, options);
            },

            forSourcePost(source, options) {
                return metricRetrievalFunction(sourcePostMetrics, source, options);
            },

            forSourceStory(source, options) {
                return metricRetrievalFunction(sourceStoryMetrics, source, options);
            },

            forSourceStoryDay(source, options) {
                return metricRetrievalFunction(sourceStoryDayMetrics, source, options);
            },

            forSourcePostAggregates(source, options) {
                return metricRetrievalFunction(sourcePostAggregateMetrics, source, options);
            },

            forSourceStoryAggregates(source, options) {
                return metricRetrievalFunction(sourceStoryAggregateMetrics, source, options);
            }
        };

        return exported;
    }
})();
